import * as React from 'react'
import { IndicatorsContainerProps, components } from 'react-select'
import { TSkillOption } from '../skill-select.types'

export const IndicatorsContainer = (
  props: IndicatorsContainerProps<TSkillOption, true>
) => (
  <components.IndicatorsContainer {...props} className="px-1 cursor-pointer" />
)
